
import { 
    postData, getDataWithParams, errorHelper, destroyData, putData, downloadFile
} from '@/store/api/method'
const requestInit = {
    page: 1,
    show: 10,
    sortBy: null,
    sorting: null,
    search: null,
}
const itemInit = {
    id: null,
    name: null,
    email: null,
    personal_email: null,
    username: null,
    company_activity_position: null,
    gender: null,
    is_active: true,
    periode: null,
    date: null,
}
const initialState = () => ({
    data: {},
    request: {...requestInit},
    item: {...itemInit},
})
const state = initialState
 
const getters = {
    getData: state => state.data || {},
    getRequest: state => state.request,
    getItem: state => state.item
}

const actions = {
    resetItem({commit}){
        commit('SET_ITEM',{...itemInit})
    },
    setItem({commit}, value){
        commit('SET_ITEM',{...value})
    },
    async fetchData(_, request) {
        try {
          const response = await getDataWithParams('/skl-student', request)
          return response.data
        }
        catch (err) {
          return errorHelper(err)
        }
    },
    async fetchListData(_, request) {
        try {
          const response = await getDataWithParams('/skl-student-list', request)
          return response.data
        }
        catch (err) {
          return errorHelper(err)
        }
    },
    async store(_, data = {}) {
        try {
            const response = await postData('/skl-student',data);
            return response.data
        } catch (err) {
            return errorHelper(err)
        }
    },
    async update(_, data = {}) {
        try {
            const response = await putData(`/skl-student-list/${data.id}`,data);
            return response.data
        } catch (err) {
            return errorHelper(err)
        }
    },
    async destroy(_, item) {
        try {
            const response = await destroyData(`/skl-student/${item.id}`);
            return response.data
        } catch (err) {
            return errorHelper(err)
        }
    },
    async downloadSkl(_, id) {
        try {
            const response = await downloadFile(`/skl-student/download/${id}`);
            return {status: 1, data: response.data}
        } catch (err) {
            return errorHelper(err)
        }
    },
    resetState({commit}){
        commit('resetState')
    }
}

const mutations = {
    SET_REQUEST(state, value){
        state.request = value
    },
    SET_ITEM(state, value){
        state.item = value
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}